var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",class:{ '-active': _vm.active }},_vm._l((_vm.message),function(item,index){return _c('span',{key:index.toString(),staticClass:"toast__item"},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }